module.exports = __webpack_public_path__ + "img/ArrowCircleUp.5e8dd89e.svg";